<div [ngStyle]="style()"></div>
